import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import BookingForm from "@/components/BookingForm";
import MarkAsNcrDialog from "@/components/MarkAsNcrDialog";
import RebookDialog from "@/components/RebookDialog";

// Edit form, delete confirm, NCR and rebook dialogs driven by useBookingActions.
export default function BookingsDialogs({ actions: a, refresh }) {
  return (
    <>
      <BookingForm
        open={!!a.editing}
        onOpenChange={(open) => !open && a.setEditing(null)}
        booking={a.editing?.__new ? null : a.editing}
        onSaved={refresh}
      />
      <AlertDialog open={!!a.confirmDelete} onOpenChange={(open) => !open && a.setConfirmDelete(null)}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Delete booking?</AlertDialogTitle>
            <AlertDialogDescription>
              {a.confirmDelete?.reference_number} will be permanently removed. This cannot be undone.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={a.confirmDeleteNow} className="bg-red-600 hover:bg-red-700"
                               data-testid="confirm-delete-booking">
              Yes, delete
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
      <MarkAsNcrDialog
        open={!!a.ncrBooking}
        onOpenChange={(open) => !open && a.setNcrBooking(null)}
        booking={a.ncrBooking}
        onCreated={() => { a.setNcrBooking(null); refresh(); }}
      />
      <RebookDialog
        open={!!a.rebookSource}
        source={a.rebookSource}
        onClose={() => a.setRebookSource(null)}
        onConfirm={a.submitRebook}
      />
    </>
  );
}
